define('native/models/TouchIdModel',['knockout'], function (ko) {

    return function TouchIdModel (createLocalStorageAccessor, session, loginModel) {

        var self = this;

        self.touchIdEmail =  createLocalStorageAccessor('touchIdEmail');

        self.deviceIsUsingTouchId = ko.pureComputed({
            read: function () {
                return !!self.touchIdEmail();
            },
            write: function (newValue) {
                if (newValue) {
                    // Set the touchIdEmail to the current user
                    self.touchIdEmail(session.getAssociatedPlayer().contactInfo.email());
                } else {
                    self.touchIdEmail(null);
                }
            }
        });

        self.currentUserIsUsingTouchId = ko.pureComputed(function () {
            var selectedPlayer = loginModel.user();

            if (session.loggedIn()) {
                selectedPlayer = session.getAssociatedPlayer().contactInfo.email();
            }

            return self.touchIdEmail() === selectedPlayer;
        });

        self.canConfigureTouchId = ko.pureComputed(function () {
            // Can configure touch id if there is biometrics, and the current user is the configured
            // touchid user, or there is no touch id user
            return self.deviceHasTouchId() &&
                (self.currentUserIsUsingTouchId() || !self.deviceIsUsingTouchId());
        });

        self.shouldShowTouchIdForLogin = ko.pureComputed(function () {
            return  self.deviceHasTouchId() && self.deviceIsUsingTouchId() &&
                (self.currentUserIsUsingTouchId() || loginModel.user() === '');
        });

        self.canLoginWithTouchId = ko.pureComputed(function () {
            return self.deviceHasTouchId() && self.currentUserIsUsingTouchId();
        });

        self.deviceHasTouchId = ko.observable(window.native && window.native.biometrics).withFallback(false);

        self.hasShownTouchIdOption = createLocalStorageAccessor('touchIdOptionShown').withFallback(false);
    };
});


